<template>
  <div class="table-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong class="first"><h3>{{$t('store.table.table')}}</h3></strong>
            </div>
            <legend class="col-sm-2 col-form-label">
              <span style="margin-right: 15px;">
                {{$t('store.table.active')}}
              </span>
              <c-switch style="margin-top: 0" class="active" type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.active" :value="1" :uncheckedValue="0" />
            </legend>
          </div>
        </b-col>
      </b-row>
      <b-row class="pb-15">
        <b-col cols="12">
          <b-card class="header mb-0" header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('banner.basic_information') }}</strong>
              <label class="switch switch-sm switch-text switch-info float-right" >
              </label>
            </div>
            <b-collapse :visible.sync="basicInformationStatus" id="basic_information_content">
              <b-form class="row">
                <b-col cols="12">
                  <div class="form-group row" >
                    <legend class="col-sm-2 col-form-label">{{$t('store.table.sku')}} <span class="text-danger">*</span></legend>
                    <div class="col-sm-5">
                      <b-form-input type="text"
                                    name="sku"
                                    class="form-control border-radius-4px"
                                    v-model="item.sku"
                                    v-bind:placeholder="$t('common.text_en')"
                      />
                    </div>
                  </div>
                  <div class="form-group row" >
                    <legend class="col-sm-2 col-form-label">{{$t('store.table.name')}} <span class="text-danger">*</span></legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id">
                      <b-form-input type="text"
                                    :name="`name[${lang}]`"
                                    class="form-control border-radius-4px"
                                    v-model="item.name[lang]"
                                    v-bind:placeholder="$t('common.text_' + lang)"
                      />
                    </div>
                  </div>
                  <div class="form-group row" >
                    <legend class="col-sm-2 col-form-label">{{$t('store.table.description')}}</legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id" >
                      <count-text-area v-model="item.description[lang]" :placeholder="$t('common.text_' + lang)">
                      </count-text-area>
                    </div>
                  </div>
                </b-col>
              </b-form>
            </b-collapse>
            <div slot="footer">
              <div class="back-button">
                <button type="button" class="btn border-radius-4px bg-main float-left" @click="$router.push({name: 'table-control', params: { uuid: $route.params.uuid }})"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</button>
              </div>
              <div class="btn-save">
                <button type="button" class=" pull-right btn bg-main border-radius-4px pl-3 pr-3" v-on:click="saveTable()" :disabled="checkSubmit() "> {{$t('common.save')}}</button>
              </div>
             </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import SelectDropdown from '../../../components/Partials/SelectDropdown'
  import {required} from 'vuelidate/lib/validators'
  import vSelect from 'vue-select'
  import MaskedInput from 'vue-text-mask'
  import cSwitch from '../../../components/Switch'
  import CustomizeField from '../../../components/Partials/CustomizeField'
  import CountTextArea from '../../../components/Partials/CountTextArea'
  import DatePickerInput from '@/components/Partials/DatePickerInput'

  let vm = null
  var defaultDateFrom = '01-01-2018 00:00:00'
  var defaultDateTo = '30-12-9998 23:59:00'
  export default {
    name: 'BannerForm',
    props: {
      uuid: {
        type: String,
        required: true,
        default: 'create'
      }
    },
    components: {
      vSelect,
      MaskedInput,
      SelectDropdown,
      CustomizeField,
      CountTextArea,
      cSwitch,
      DatePickerInput
    },
    data: function () {
      return {
        item: {
          id: null,
          uuid: '',
          sku: '',
          name: {},
          description: {},
          active: 1,
        },
        basicInformationStatus: true,
        outletId: '',
        tableID: ''
      }
    },
    mixins: [
      validationMixin
    ],
    validations: {
      item: {
        name: {
          en: {
            required
          }
        },
        sku: {
          required
        }
      }
    },
    methods: {
      checkSubmit: function () {
        let validateName = false
        let form = vm.$v.item.$invalid
        return form || validateName
      },
      getStoreInfo (uuid) {
        const vm = this
        vm.axios.outlet.getOutletDetail(uuid, response => {
          if (response.status === 200) {
            let data = response.data.data.item
            vm.outletId = data.id
          }
        }, error => {
          console.log('error', error)
        })
      },
      saveTable () {
        var data = JSON.parse(JSON.stringify(vm.item))
        data.outlet_id = this.outletId
        if (vm.item.uuid == '' || vm.item.uuid == 'create') {
          vm.axios.outlet.createTable(data, function (response) {
            vm.$toastr.success(vm.$t('message.save_successful'), vm.$t('message.success'), {})
            vm.$router.push({'name': 'table-control'})
          }, function () {
          })
        } else {
          vm.axios.outlet.updateTable(data, function (response) {
            vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
            vm.$router.push({'name': 'table-control'})
          }, function () {
          })
        }
        
        
      },
      getTableDetail(id) {
        let vm = this
        if (id === 'create') return
        vm.axios.outlet.getTableDetail(id,
          function (response) {
            let item = response.data.data.item
            if (item.description == null) {
              item.description = {'en': ''}
            }

            vm.item = item
          })
      },
      
    },
    created: function () {
      vm = this
    },
    mounted: function () {
      if (this.$route.params.uuid) {
        this.getStoreInfo(this.$route.params.uuid)
      }
      if (this.$route.params.action !== 'create') {
        this.getTableDetail(this.$route.params.action)
      }
    },
    watch: {
    }
  }
</script>

<style scoped>

  .pl-20 {
    padding-left: 20px !important;
  }

  .message-text {
    font-size: 12px;
    padding-bottom: 5px;
  }

  .error-message {
    color: #f86c6b;
  }

  .reset-custom {
    margin-right: 10px;
    margin-top: 7px;
    color: #0091FF !important;

  }

  .back-button {
    padding-left: 25px;
    width: 95px;
    float: left;
  }

  .table-text {
    text-align: center;
  }

  .button-left {
    text-align: left;
  }

  .switch-customize {
    height: 24px !important;
    border: none;
    background-color: transparent !important;
    margin-bottom: 0px;
  }

  .m-t-20 {
    margin-top: 20px !important;
  }

  .none-border {
    border: 0px solid #d1d4d7 !important;
  }

  .card-body {
    border: 1px solid #d1d4d7 !important;
  }

  .border-red {
    border-color: red;
  }

  .delete-date {
    font-size: 18px;
    font-weight: bold;
  }

  .table-form .switch.switch-icon{
    margin-top: 5px;
  }

  .table-form .header-custom-switch{
    margin-top: 5px;
    margin-bottom: 0;
  }

  .table-form .header-custom-switch .col-form-label{
    text-align: right;
  }

  .table-form .header-custom-switch .uppercase{
    display: inline-flex;
  }

  .table-form .btn-save{
    float: right !important;
    padding-right: 22px;
    margin-right: 0px !important;
    box-sizing: border-box;
    text-align: right;
  }
  /*END Form Wizard*/
</style>

<style>
  .preview-image {
    width: 100%;
  }

  .table-form .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
  .table-form div.header,
  .table-form .header .card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

  .close-btn .fa-angle-right {
    margin-right: -4px;
  }
  .close-btn .fa-angle-left {
    margin-left: -4px;
  }
  .table-form .btn-primary .fa{
    font-size: 20px;
  }
  .table-form .btn-primary {
    color: #0091ff;
    background-color: transparent;
  }
  .table-form .btn-primary:hover{
    color: #0091ff;
    background-color: transparent;
  }
  .pt-05{
    padding: 0.5rem;
  }
  .pb-15{
    padding-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/outlets/TableForm.vue